/** @enum {string} */
export const Priority = Object.freeze({
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low',
});

export const PRIORITY_ORDER = [Priority.HIGH, Priority.MEDIUM, Priority.LOW];
